import { z } from 'zod/v4';

import { columns } from './columns';

export const marketIndustryAdjustmentSchema = z.object(columns);

export type MarketIndustryAdjustment = z.output<
  typeof marketIndustryAdjustmentSchema
>;
